import { brandConfig } from '../../config/brands';
import { useAuthLogo } from '../../hooks/useAuthScheme';

/** オンボーディング・組織設定系ページ (auth-pages.css) 共通のブランドロゴ。
 *  ログイン画面 (AuthGate / AuthPages.module) と同じく「カードの上」に配置する。
 *  配色 (data-auth-scheme) に応じて logoDark / logoWhite を自動で切り替える。 */
export function AuthBrandLogo() {
  const logo = useAuthLogo();
  return (
    <div className="auth-brand-logo">
      <img
        src={logo.src}
        alt={brandConfig.serviceName}
        className={logo.invert ? 'onboarding-logo--invert' : undefined}
      />
    </div>
  );
}
